module.exports = __webpack_public_path__ + "img/修车.56019414.png";